import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import {servicoPlanosComponentName} from "../../shared/data.service";

@Component({
    selector: 'app-servico-plano-table',
    template: require('./servico-plano-table.component.html'),
    styles: [require('./servico-plano-table.component.css')]
})
export class ServicoPlanoTableComponent implements OnInit {
    @Input() list: any[] = [];
    @Input() showRemove: boolean = false;
    @Output() removeEvent: EventEmitter<any> = new EventEmitter();

    servicoPlanosName: any = servicoPlanosComponentName;

    constructor() { }

    ngOnInit() {
    }

    clickRemove(item: any, index: number) {
        this.removeEvent.next([item, index]);
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/manutencoes/servicos/servico-planos/servico-plano-table/servico-plano-table.component.ts
 **/